import { c as _c } from "react/compiler-runtime";
import { Heading, Text, VStack } from '@chakra-ui/react';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import { RequestDeleteForm } from '@src/components/sco/Requests/RequestDeleteForm';
import React from 'react';

/**
 * Final RequestBuilder accordion section: delete.
 * The publish workflow (PublishRequestForm) is hidden while GroupRequest publishing is turned off.
 */
export const SettingsPublishSection: React.FC<RequestBuilderFormProps> = props => {
  const $ = _c(5);
  const groupRequestId = props.groupRequest?.groupRequestId;
  if (!groupRequestId) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <VStack align="stretch" padding={4}><Text color="fg.muted">Request not loaded yet.</Text></VStack>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Heading fontWeight="semibold" size="sm">Danger zone</Heading>;
    t1 = <Text color="fg.muted" textStyle="sm">Permanently remove this request and related workspace data (game plan, matches, activity).</Text>;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== groupRequestId) {
    t2 = <VStack align="stretch" gap={6} padding={4}><VStack align="stretch" gap={3}>{t0}{t1}<RequestDeleteForm groupRequestId={groupRequestId} /></VStack></VStack>;
    $[3] = groupRequestId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};